import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  Name: "Guest self service",
  Currency: "",
  HotelId: "",
  HotelData: {},
  RoomData: {},
  HomepageData: {},
  SummaryData: {},
  Shops: [],
  SelectedShopId: "",
  SelectedShopProducts: {},
  ExtendCheckoutSlot: "",
  CartShopProducts: [],
  CartRoomUpgrade: null,
  CartExtendCheckout: null,
  CartSelfCheckIn: null,
  CartSettleDues: null,
  EarlyCheckinnSlot: "",
  CartEarlyCheckin: null,
  IsSingleFlow: false,
  PrimaryGuestDetail: {},
  RoomUpgradeReservationId: "",
  pgInfo: {},
  guestRegistrationData: {},
};

const store = createSlice({
  name: "Auth",
  initialState,
  reducers: {
    saveName: (state, action) => {
      state.Name = action.payload;
    },
    saveCurrency: (state, action) => {
      state.Currency = action.payload;
    },
    saveHotelId: (state, action) => {
      state.HotelId = action.payload;
    },
    saveHotelData: (state, action) => {
      state.HotelData = action.payload;
    },
    saveRoomData: (state, action) => {
      state.RoomData = action.payload;
    },
    saveHomepageData: (state, action) => {
      state.HomepageData = action.payload;
    },
    saveSummaryData: (state, action) => {
      state.SummaryData = action.payload;
    },
    saveShops: (state, action) => {
      state.Shops = action.payload;
    },
    saveSelectedShopId: (state, action) => {
      state.SelectedShopId = action.payload;
    },
    saveSelectedShopProducts: (state, action) => {
      state.SelectedShopProducts = action.payload;
    },
    saveExtendCheckoutSlot: (state, action) => {
      state.ExtendCheckoutSlot = action.payload;
    },
    saveCartShopProducts: (state, action) => {
      state.CartShopProducts = action.payload;
    },
    saveCartRoomUpgrade: (state, action) => {
      state.CartRoomUpgrade = action.payload;
    },
    saveCartExtendCheckout: (state, action) => {
      state.CartExtendCheckout = action.payload;
    },
    saveCartSelfCheckIn: (state, action) => {
      state.CartSelfCheckIn = action.payload;
    },
    saveCartSettleDues: (state, action) => {
      state.CartSettleDues = action.payload;
    },
    saveEarlyCheckinnSlot: (state, action) => {
      state.EarlyCheckinnSlot = action.payload;
    },
    saveCartEarlyCheckin: (state, action) => {
      state.CartEarlyCheckin = action.payload;
    },
    saveIsSingleFlow: (state, action) => {
      state.IsSingleFlow = action.payload;
    },
    savePrimaryGuestDetail: (state, action) => {
      state.PrimaryGuestDetail = action.payload;
    },
    saveRoomUpgradeReservationId: (state, action) => {
      state.RoomUpgradeReservationId = action.payload;
    },
    savePgInfo: (state, action) => {
      state.pgInfo = action.payload;
    },
    saveGuestRegistrationData: (state, action) => {
      state.guestRegistrationData = action.payload;
    },
  },
});

export const {
  saveName,
  saveCurrency,
  saveHotelId,
  saveHotelData,
  saveRoomData,
  saveHomepageData,
  saveSummaryData,
  saveShops,
  saveSelectedShopId,
  saveSelectedShopProducts,
  saveExtendCheckoutSlot,
  saveCartShopProducts,
  saveCartRoomUpgrade,
  saveCartExtendCheckout,
  saveCartSelfCheckIn,
  saveCartSettleDues,
  saveEarlyCheckinnSlot,
  saveCartEarlyCheckin,
  saveIsSingleFlow,
  savePrimaryGuestDetail,
  saveRoomUpgradeReservationId,
  savePgInfo,
  saveGuestRegistrationData,
} = store.actions;

export default store.reducer;
